module.exports = __webpack_public_path__ + "img/img_statement_retail@3x.c19bfee9.png";